"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlameRating64Recommend = function SvgFlameRating64Recommend(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame-rating-64-recommend_svg__a",
    x1: "77.099%",
    x2: "46.243%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF7F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.035%",
    stopColor: "#FA4668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E067AE"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#flame-rating-64-recommend_svg__a)",
    d: "M24.7 56.973C11.387 56.495.74 45.551.74 32.121.74 18.39 11.871 7.256 25.603 7.253l.002-.136c8.024-.589 11.507-4.774 11.507-4.774s.821 2.66 1.075 6.753a29.123 29.123 0 0 0 1.353-1.407C41.572 5.396 43.171 2.826 44.02 0c0 0 9.095 7.746 5.778 25.068 3.201-.872 3.732-4.772 3.828-7.948C55.6 21.272 60.404 58.54 24.7 56.99v-.017z",
    opacity: 0.95,
    transform: "matrix(-1 0 0 1 59.74 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.909 30.579c-.939.127-1.696-.242-2.272-1.107-.865-1.297-2.036-3.395-2.92-4.204-.885-.81-3.046-4.985-3.318-5.952-.272-.967-.603-2.316-1.38-2.316-.775 0-2.153.677-2.153 2.782s1.005 3.535 1.292 4.666c.287 1.132.066 2.798-1.292 2.798s-4.962-.8-6.111-.8c-1.15 0-3.333-.015-3.333 1.505-.016.636.14 1.143.47 1.521-1.262.554-1.892 1.307-1.892 2.26 0 .952.474 1.554 1.422 1.804-.777.732-1.166 1.457-1.166 2.173 0 .715.545 1.332 1.635 1.848-.312.633-.469 1.219-.469 1.757 0 .807.929 1.717 3.333 2.068 2.403.35 8.937.46 11.53-.246 2.592-.706 3.514-1.822 4.797-1.822h1.827v-8.735z"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlameRating64Recommend);
var _default = Memo;
exports["default"] = _default;